
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/switch-with-jove",
      function () {
        return require("private-next-pages/switch-with-jove/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/switch-with-jove"])
      });
    }
  